import React, { useRef, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import UiModal from "../../common/ui/UiModal";
import * as Yup from "yup";
import { ERRORS } from "../../constants/user-info.const";
import { FederalTaxFormFields, FederalTaxInfo } from "../models/user-interface";
import FederalTaxesForm from "../user-forms/FederalTaxesForm";
import { connect } from "react-redux";
import { formSubmitErrorHandler } from "../../../services/formService";
import { updateFederalTaxes } from "../../../services/api-services/federalTaxService";

interface ModalProps {
  open: boolean;
  handleClose: (result?: any, action?: any) => void;
  federalTaxInfo: FederalTaxInfo | undefined;
  filingStatus: any;
  FederalTaxUpdateCallback: (result?: any) => void;
}
function FederalTaxInfoEditModal(props: ModalProps) {
  const {
    open,
    handleClose,
    federalTaxInfo,
    filingStatus,
    FederalTaxUpdateCallback,
  } = props;
  const formRef: any = useRef();
  const title = "Edit Federal Tax Information";
  const validationSchema = Yup.object({
    filing_status: Yup.string().required(ERRORS.filing_status),
    deductions: Yup.number().max(1000000000, ERRORS.deductionAmountMaxValue)
    .min(0, ERRORS.deductionAmountMinValue),
    dependents_amount: Yup.number().max(1000000000, ERRORS.dependentAmountMaxValue)
    .min(0, ERRORS.dependentAmountMinValue),
    other_income: Yup.number().max(1000000000, ERRORS.otherIncomeMaxValue)
    .min(0, ERRORS.otherIncomeMinValue),
    extra_withholding: Yup.number().max(1000000000, ERRORS.withHoldingAmountMaxValue)
    .min(0, ERRORS.withHoldingAmountMinValue),
  });
  const [isShowFooterLoader, setIsShowFooterLoader] = useState<boolean>(false);

  const getFormData = (data: FederalTaxFormFields) => {
    const inputs = {
      version: federalTaxInfo?.version,
      filing_status: data?.filing_status,
      dependents_amount: data?.dependents_amount,
      other_income: data?.other_income,
      two_jobs: data?.two_jobs === "Yes" ? true : false,
      deductions: data?.deductions,
      extra_withholding: data?.extra_withholding,
    };
    return inputs;
  };
  const onSubmit = (data: FederalTaxFormFields, formHelpers: FormikHelpers<any>) => {
    const formInputs = getFormData(data);
    setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      updateFederalTaxes(formInputs).then((res : any) => {
        setIsShowFooterLoader(false);
        FederalTaxUpdateCallback(res?.data);
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };
  return (
    <UiModal
      open={open}
      handleClose={handleClose}
      title={title}
      handleSave={() => {
        formRef.current?.handleSubmit();
      }}
      showFooterLoader={isShowFooterLoader}
    >
      <Formik
        initialValues={{
          filing_status: federalTaxInfo?.filing_status ?? '',
          dependents_amount: federalTaxInfo?.dependents_amount ?? '0.0',
          other_income: federalTaxInfo?.other_income ?? '0.0',
          two_jobs: federalTaxInfo?.two_jobs ? "Yes" : "No",
          deductions: federalTaxInfo?.deductions ?? '0.0',
          extra_withholding: federalTaxInfo?.extra_withholding ?? '0.0',
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {() => {
          return (
            <Form>
              <FederalTaxesForm filingStatus={filingStatus} />
            </Form>
          );
        }}
      </Formik>
      
    </UiModal>
  );
}
const mapStateToProps = (state) => ({
  filingStatus: state.config?.employees?.federal_taxes?.filing_statuses,
});
export default connect(mapStateToProps)(FederalTaxInfoEditModal);
